import { atom } from "recoil";
import { getTooltips } from "../services/api";
import { InnerTooltipType } from "../types";

export const TooltipsListState = atom<InnerTooltipType[]>({
	key: "TooltipsListState",
	default: getTooltips(),
});
